/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Verify_Password_PlaceholderInputs */



/**
* | output |
* | --- |
* | "At least 8 characters" |
*
* @param {Auth_Verify_Password_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const auth_verify_password_placeholder = /** @type {((inputs?: Auth_Verify_Password_PlaceholderInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Verify_Password_PlaceholderInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Au moins 8 caractères")
	if (locale === "es") return /** @type {LocalizedString} */ ("Al menos 8 caracteres")
	if (locale === "pt") return /** @type {LocalizedString} */ ("No mínimo 8 caracteres")
	if (locale === "it") return /** @type {LocalizedString} */ ("Almeno 8 caratteri")
	return /** @type {LocalizedString} */ ("At least 8 characters")
});